import { render, staticRenderFns } from "./savedialog.vue?vue&type=template&id=2c931da2&"
import script from "./savedialog.vue?vue&type=script&lang=js&"
export * from "./savedialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports